import { useQuery } from "@tanstack/react-query";
import { useApi } from "@/core/api";
import type { PocketflowsEmbedUrlResponse } from "./campaign";

export const pocketflowsEmbedUrlKey = (businessId?: string | null) =>
  ["pocketflows-embed-url", businessId] as const;

export const useGetPocketflowsEmbedUrl = (businessId: string | null) => {
  const api = useApi();

  return useQuery<PocketflowsEmbedUrlResponse>({
    queryKey: pocketflowsEmbedUrlKey(businessId),
    queryFn: () =>
      api
        .post("/pocketflows/embedded_iframes", { business_id: businessId })
        .then((res) => res.data),
    enabled: !!businessId,
    retry: false,
  });
};
